import React from "react";
import ReactPlayer from 'react-player';
import Gallery from "../../models/gallery.model";

interface videoPlayerInterface{
  video:Gallery
}

const VideoPlayer:React.FC<videoPlayerInterface> = (props)=>{

  const {video} = props;

  return(
    <div style={{width:"100%", boxShadow:'0 0 5px rgba(0,0,0,0.3)'}} className="video-wrapper">
      <ReactPlayer url={video.value} controls={true}/>
      <h3 className="text-16-primary text-center p-1">{video.name}</h3>
    </div>
  )
}


export default VideoPlayer;